import { SelectOption } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

const getLabel = (key: string): string => {
  if (key === 'contracts_fixed_amount_strategy') {
    return i18n.t(
      'contract_versions.additional_compensation.amount_strategy_labels.contracts_fixed_amount_strategy'
    )
  }
  if (key === 'contracts_variable_amount_strategy') {
    return i18n.t(
      'contract_versions.additional_compensation.amount_strategy_labels.contracts_variable_amount_strategy'
    )
  }

  return key.charAt(0).toUpperCase() + key.slice(1)
}

export const createSelectOptions = <T extends string>(
  values: readonly (T | { value: T; label: string })[]
): SelectOption[] =>
  values.map((item) =>
    typeof item === 'string'
      ? { label: getLabel(item), value: item }
      : { label: item.label, value: item.value }
  )

export const parseDateString = (value: string | null | undefined): moment.Moment | null => {
  if (!value) return null

  const valueString = String(value).trim()
  const isBackendFormat = /^\d{4}-\d{2}-\d{2}$/.test(valueString)

  try {
    if (isBackendFormat) {
      return stringToDate(valueString, 'backend')
    } else {
      const uiFormat = moment.localeData().longDateFormat('L')
      const parsed = moment(valueString, uiFormat, true)

      if (parsed.isValid()) {
        const backendDateString = parsed.format('YYYY-MM-DD')
        const result = stringToDate(backendDateString, 'backend')

        if (result.isValid()) {
          return result
        }
      }

      try {
        const fallbackParsed = stringToDate(valueString, 'ui')
        if (fallbackParsed.isValid()) {
          const backendDateString = fallbackParsed.format('YYYY-MM-DD')
          return stringToDate(backendDateString, 'backend')
        }
      } catch {
        // no-op
      }

      return null
    }
  } catch (error) {
    return null
  }
}
